import classNames from 'classnames';
import React from 'react';
import { defaultProps } from 'recompose';

const Embed = ({ aspectRatio, children, className, ...props }) => (
  <div
    className={classNames(`embed-responsive embed-responsive-${aspectRatio}`, className)}
    {...props}>
    {
      ((element) => React.cloneElement(element, {
        className: classNames('embed-responsive-item', element.props.className)
      }))(React.Children.only(children))
    }
  </div>
);

export default defaultProps({
  aspectRatio: '16by9'
})(Embed);



// WEBPACK FOOTER //
// ./src/components/proxy/embed.js